import { Image, Select, Spin, Table } from 'antd';
import axios from '../axios'
import '../styles/HatchHistory.css';

import { useEffect, useState } from 'react'
import getUsernamesFromUserId from '../modules/getUsernamesFromUserId';

function HatchHistory() {
  const [selectedPlayer, setSelectedPlayer] = useState('all');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [server, setServer] = useState(() => {
    const server = localStorage.getItem('selectedServer');
    return server ? JSON.parse(server) : null;
  });
  const [pageSize, setPageSize] = useState(10); // Add state for page size

  useEffect(() => {
    async function init() {
      axios.get(`/api/user/hatchHistory/${server?.id}`)
        .then(async (res) => {
          var playerIds = res.data.map(data => data.player.robloxUserId);
          var usernames = await getUsernamesFromUserId(playerIds);
          res.data.forEach(element => {
            element.player.username = usernames.find(u => u.id === element.player.robloxUserId).name;
          });
          setData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          window.location.reload();
        });
    }

    init();


  }, [])

  const columns = [
    {
      title: 'Icon',
      dataIndex: 'hatchHistory.hugeThumbnail',
      key: 'thumbnail',
      render: (text, record) => (
        <Image width={50} src={`https://ps99.biggamesapi.io/image/${record.thumbnail}`} preview={false} />
      )
    },
    {
      title: 'Huge Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Variant',
      dataIndex: 'variantType',
      key: 'variant',
      sorter: (a, b) => a.variantId - b.variantId,
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'quantity',
      render: (text, record) => {
        var username = data.find(data => data.player.id === record.playerId)?.player.username;
        return <span>{username}</span>;
      }
    },
    {
      title: 'Date',
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (text, record) => (
        <span>{new Date(record.timestamp * 1000).toLocaleString()}</span>
      ),
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.timestamp - b.timestamp,
    },
  ];

  const handleTableChange = (pagination) => {
    setPageSize(pagination.pageSize);
  };

  const filteredHuges = selectedPlayer === 'all' ? data.map((item) => item.hatchHistory).flat() : (data.find(data => data.player.id === selectedPlayer)?.hatchHistory || []);

  return (
    <div className='section-2'>
      {loading ? (
        <Spin size="large" />
      ) : (
        <>
          <Select
            defaultValue={selectedPlayer}
            style={{ width: 150, textAlign: 'center' }}
            options={[{ label: 'All Players', value: 'all' }, ...data.map(data => ({ label: data.player.username, value: data.player.id }))]}
            onChange={value => setSelectedPlayer(value)}
          />
          <Table
            className='section-2-table'
            dataSource={filteredHuges}
            columns={columns}
            rowKey="id"
            scroll={{ y: window.innerHeight - 300 }} // Adjust the height dynamically based on window height
            pagination={{
              pageSize, // Controlled by state
              showSizeChanger: true, // Enable page size dropdown
              pageSizeOptions: ['10', '20', '50', '100'], // Custom options
              onShowSizeChange: (current, size) => setPageSize(size), // Update state on change
            }}
          />
        </>
      )}
    </div>
  )
}

export default HatchHistory
